import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';

import aboutStyle from '../../assets/jss/material-kit-react/views/landingPageSections/aboutStyle';

class AboutSection extends React.Component {
  render() {
    const { classes, aboutContent = '', papers = '' } = this.props;
    if (!aboutContent.html) {
      return (
        <div className={classes.section} id='about'>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={8}>
              <h2 className={classes.title}>About</h2>
              <p className={classes.p}>
                The AskOski Project seeks to improve equity and achievement in higher education by making colleges and universities first-class beneficiaries of human-centered AI research.
              </p>
              <p className={classes.p}>
                AskOski, named after Cal's sports mascot, is a personalized course recommendation system that collects various University data into a central platform allowing students to illuminate their academic terrain like never before. The system incorporates degree audit, course description, and historic enrollment information combined with machine learning to help students explore their interests, connect course concepts across departments, draw up plans for future semesters, while satisfying complex constraints of their programs.
              </p>
              <p className={classes.p}>
                This system is a product of ongoing research in data science, education, and cognition conducted by the Computational Approaches to Human Learning (CAHL) research lab in collaboration with the UC Berkeley Office of the Registrar. It is not meant to replace academic advising but rather allow students to see the course pathways taken by students with similar course histories and majors and explore topical relationships between courses as informed by their peers. In this sense, the information provided are not objective, but rather an alternative source of perspective on the conceptual landscape of the university which we hope students find informative.
              </p>
              <p className={classes.p}>
                Projects in learning analytics, such as this one, require the engagement of a cross-campus community. Our research is supported by NSF grants (#1547055 and #1446641), and we thank the following UCB staff for their essential past and continuing support: Andrew Eppig (OPA), Mark Chiang (EDW), Anji Gannavarapu (EDW), Daniel Grieb (EDW), Raul Infante (OR), Aswan Movv (EDW), Max Michel (EDW), Jen Stringer (ETS), Larry Conrad (CIO), Johanna Metzgar (OR), and Walter Wong (Registrar).
              </p>
            </GridItem>
          </GridContainer>
          <div className={classes.section} id='research'>
            <GridContainer justify='center'>
              <GridItem xs={12} sm={12} md={8}>
                <h2 className={classes.title}>Research</h2>
                <div className='.MuiList-root' style={{ color: 'black', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: papers.html }} />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      );
    }
    return (
      <div className={classes.section} id='about'>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>About</h2>
            <div className={classes.p} dangerouslySetInnerHTML={{ __html: aboutContent.html }} />
          </GridItem>
        </GridContainer>
        <div className={classes.section} id='research'>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={12} md={8}>
              <h2 className={classes.title}>Research</h2>
              <div className='.MuiList-root' style={{ color: 'black', textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: papers.html }} />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(aboutStyle)(AboutSection);
